<template lang="pug">
  pre(style='font-size: 10px;')
    | auth: {{ JSON.stringify({ user, key }, null, 2)}}
    | router: {{ JSON.stringify({ path, params }, null, 2) }}
    | publicConfig: {{ JSON.stringify({ config, error, loading }, null, 2) }}
</template>

<script>
import { mapState, mapActions } from 'vuex';

const filterObj = (raw, allowed) => Object.keys(raw)
  .filter(key => allowed.includes(key))
  .reduce((obj, key) => Object.assign(obj, { [key]: raw[key] }), {});

export default {
  computed: {
    ...mapState('auth', {
      key: 'key',
      user: state => state.user && filterObj(state.user, ['id', 'email', 'username', 'surname', 'deleted_at']),
    }),
    ...mapState('router', ['path', 'params']),
    ...mapState('publicConfig', ['config', 'error', 'loading']),
  },
  methods: {
    ...mapActions('publicConfig', ['updateConfig']),
  },
  mounted() {
    this.updateConfig('lab');
  },
};
</script>



// WEBPACK FOOTER //
// TmpDebug.vue?ab8ccd68